import styled from 'styled-components';

export const NoPrintWrapper = styled.div`
	@media print {
		display: none !important;
	}
`;
